import request from '@/utils/request'

/**
 * 生成预收票据
 * @param {Object} data - { communityId, objType, objId, objName, payObjId, payObjName, feeIds, receiptCode?, remark? }
 */
export function savePreReceipt(data) {
    return new Promise((resolve, reject) => {
        request({
            url: '/receipt.savePreReceipt',
            method: 'post',
            data
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

/**
 * 查询预收票据列表
 * @param {Object} params - { communityId, page, row, objId?, objType?, statusCd? }
 */
export function queryPreReceipt(params) {
    return new Promise((resolve, reject) => {
        request({
            url: '/feeReceipt/queryFeeReceipt',
            method: 'get',
            params
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

/**
 * 查询收据明细列表
 * @param {Object} params - { communityId, receiptId, page, row }
 */
export function queryPreReceiptDetail(params) {
    return new Promise((resolve, reject) => {
        request({
            url: '/feeReceipt/queryFeeReceiptDetail',
            method: 'get',
            params
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

/**
 * 确认收款/作废预收票据
 * @param {Object} data - { communityId, receiptId, action: 'confirm'|'void' }
 */
export function confirmPreReceipt(data) {
    return new Promise((resolve, reject) => {
        request({
            url: '/receipt.confirmPreReceipt',
            method: 'post',
            data
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}

/**
 * 确认收款并生成缴费记录（直接选择收款方式）
 * @param {Object} data - { communityId, receiptId, primeRate, remark? }
 */
export function confirmPreReceiptWithPay(data) {
    return new Promise((resolve, reject) => {
        request({
            url: '/receipt.confirmPreReceiptWithPay',
            method: 'post',
            data
        }).then(response => {
            resolve(response.data)
        }).catch(error => {
            reject(error)
        })
    })
}
